import { MarketProgram } from '@/features/bidding/constants'

export function useCountryBiddableMarketProgramMap() {
  return {
    ee: [],
    es: [],
    dk: [],
    nl: [],
    fi: [
      MarketProgram.NORDICS_FCRD_DOWN_STATIC,
      MarketProgram.NORDICS_FCRD_UP_STATIC,
      MarketProgram.NORDICS_FCRD_DOWN_DYNAMIC,
      MarketProgram.NORDICS_FCRD_UP_DYNAMIC,
      MarketProgram.NORDICS_FCRN,
      MarketProgram.FCRN,
      MarketProgram.FFR_UP,
      MarketProgram.MFRR_DOWN,
      MarketProgram.MFRR_UP,
    ],
    gr: [MarketProgram.MFRR_UP, MarketProgram.MFRR_DOWN],
    no: [MarketProgram.MFRR_UP, MarketProgram.MFRR_DOWN],
    se: [
      MarketProgram.FCRD_UP,
      MarketProgram.FCRD_DOWN,
      MarketProgram.MFRR_UP,
      MarketProgram.MFRR_DOWN,
      MarketProgram.NORDICS_FCRD_DOWN_STATIC,
      MarketProgram.NORDICS_FCRD_UP_STATIC,
      MarketProgram.NORDICS_FCRD_DOWN_DYNAMIC,
      MarketProgram.NORDICS_FCRD_UP_DYNAMIC,
    ],
  }
}
